import { http } from '../utils/http';

// 获取项目列表
export const reqFetchProjects = params =>
  http.request({
    url: `/project`,
    method: 'GET',
    params,
    withUserId: 'PARAMS'
  });

// 判断项目名称是否已经存在
export const reqJudgeProject = params =>
  http.request({
    url: `/project/judge`,
    method: 'GET',
    params,
    withUserId: 'PARAMS'
  });

// 创建项目
export const reqCreateProject = data =>
  http.request({
    url: `/project`,
    method: 'POST',
    data,
    withUserId: 'DATA'
  });

// 编辑项目
export const reqUpdateProject = data =>
  http.request({
    url: `/project`,
    method: 'PUT',
    data
  });

// 查询项目详情
export const reqShowProject = projectId =>
  http.request({
    url: `/project/${projectId}`,
    method: 'GET',
    withUserId: 'DATA'
  });

// 删除项目
export const reqDestroyProject = params =>
  http.request({
    url: `/project/`,
    method: 'DELETE',
    params
  });
